"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregate = aggregate;
const decimal_js_1 = require("decimal.js");
const line_formula_1 = require("./line-formula");
/**
 * Method C — earned standard minutes (FORMULA_AND_CALCULATION_MAP.md §2, formally
 * approved). Callers MUST pre-filter to only NORMED_WORK lines — this function has
 * no notion of entry_type (CALCULATION_ENGINE_ARCHITECTURE.md §5/§9).
 *
 * totalEarnedMinutes  = Σ line.earnedStandardMinutes
 * totalNormedMinutes  = Σ line.durationMinutes
 * performanceRatioRaw = totalEarnedMinutes / totalNormedMinutes   (if totalNormedMinutes > 0)
 * deviationRaw        = performanceRatioRaw - 1
 */
function aggregate(input) {
    let totalEarnedMinutes = new decimal_js_1.Decimal(0);
    let totalNormedMinutes = new decimal_js_1.Decimal(0);
    for (const line of input.lines) {
        totalNormedMinutes = totalNormedMinutes.add(line.durationMinutes);
        const { earnedStandardMinutes } = (0, line_formula_1.computeLine)(line);
        if (earnedStandardMinutes !== null) {
            totalEarnedMinutes = totalEarnedMinutes.add(earnedStandardMinutes);
        }
    }
    if (totalNormedMinutes.isZero()) {
        return {
            performanceRatioRaw: null,
            deviationRaw: null,
            totalNormedMinutes,
        };
    }
    const performanceRatioRaw = totalEarnedMinutes.div(totalNormedMinutes);
    const deviationRaw = performanceRatioRaw.sub(1);
    return {
        performanceRatioRaw,
        deviationRaw,
        totalNormedMinutes,
    };
}
//# sourceMappingURL=aggregation.js.map